import {apiClient} from './axios';
import {
    BubbleStyleSpec,
    EppiCostume,
    EppiCostumeDetail,
    FinalizeCostumeRequest,
    FinalizeCostumeResponse,
    GenerateCostumeRequest,
    GenerateCostumeResponse,
    PatchCostumeRequest,
    RequestHistoryItem,
    SlotGroupMeta,
} from '../types/eppiCostume';

// 백엔드 응답 shape: { items: EppiCostume[], slotGroups: SlotGroupMeta[] }
interface CostumeListResponse {
    items: EppiCostume[];
    slotGroups?: SlotGroupMeta[];
}

export interface EppiCostumeListResult {
    items: EppiCostume[];
    /** 슬롯별 AI 이미지 그룹 메타 4종. 폼이 slotType 선택에 따라 systemContext/defaultBaseImageUrl prefill. */
    slotGroups: SlotGroupMeta[];
}

export const eppiCostumeApi = {
    list: async (): Promise<EppiCostumeListResult> => {
        const result = await apiClient.get<CostumeListResponse>(
            '/admin/eppi/costumes'
        );
        return {
            items: result?.items ?? [],
            slotGroups: result?.slotGroups ?? [],
        };
    },

    getByCode: async (code: string): Promise<EppiCostumeDetail> => {
        const result = await apiClient.get<EppiCostumeDetail>(
            `/admin/eppi/costumes/${code}`
        );
        return {
            ...result,
            recentPurchases: result.recentPurchases ?? [],
        };
    },

    generate: (
        body: GenerateCostumeRequest
    ): Promise<GenerateCostumeResponse> =>
        apiClient.post<GenerateCostumeResponse>(
            '/admin/eppi/costumes/generate',
            body
        ),

    finalize: (
        code: string,
        body: FinalizeCostumeRequest
    ): Promise<FinalizeCostumeResponse> =>
        apiClient.post<FinalizeCostumeResponse>(
            `/admin/eppi/costumes/${code}/finalize`,
            body
        ),

    patch: (
        code: string,
        body: PatchCostumeRequest
    ): Promise<EppiCostume> =>
        apiClient.patch<EppiCostume>(`/admin/eppi/costumes/${code}`, body),

    listRequests: async (
        code: string,
        limit = 20
    ): Promise<RequestHistoryItem[]> => {
        const result = await apiClient.get<{items?: RequestHistoryItem[]}>(
            `/admin/eppi/costumes/${code}/requests`,
            {params: {limit}}
        );
        return (result?.items ?? []).map((it) => ({
            ...it,
            results: it.results ?? [],
        }));
    },

    /**
     * Painter 카탈로그 (V200). backend 가 shared JSON 을 in-memory 로 서빙.
     * 응답이 비어있거나 미배포 상태면 caller 가 FALLBACK_BUBBLE_STYLES 로 대체.
     */
    listBubbleStyles: async (): Promise<BubbleStyleSpec[]> => {
        const result = await apiClient.get<{styles?: BubbleStyleSpec[]}>(
            '/admin/bubble-styles'
        );
        return result?.styles ?? [];
    },
};
